import React from "react";

// function LandingPage() {
//   return (
//     <div className="container">
//       <div className="row">
//         <div className="col-8">
//           <p>Hello, I'm</p>
//           <h1 className="title" id="home">
//             Devika
//           </h1>
//           <p className="subheading">
//             A passionate designer and developer who loves to create
//             user-friendly and functional solutions.
//           </p>
//           <button>Read my blog</button> <button>Contact me</button>
//         </div>

//         <div className="col-4">
//           <img
//             src="assets/Profile-pic.jpg"
//             alt="profile"
//             style={{ height: "500px", width: "400px" }}
//           />
//         </div>
//       </div>
//     </div>
//   );
// }

import styled from "styled-components";
import "bootstrap/dist/css/bootstrap.min.css";
import "../index.css";

const Section = styled.section`
  background-color: var(--background-color);
  color: white;
  padding: 4rem 1rem;
`;

const SubText = styled.p`
  color: var(--text-color);
  font-size: 1.5rem;
  font-weight: 300;
  max-width: 700px;
  line-height: 1.2;

  @media (max-width: 768px) {
    text-align: center;
    margin: 0 auto;
  }
`;

const Button = styled.button`
  border: 2px solid #c69ffb;
  color: #c69ffb;
  background: transparent;
  border-radius: 25px;
  padding: 10px 25px;
  margin-right: 15px;
  font-weight: 500;
  margin-top: 1.5rem;
  transition: 0.3s;

  &:hover {
    background-color: #c69ffb;
    color: #1e1e1e;
  }

  @media (max-width: 768px) {
    margin-right: 10px;
    margin-top: 1rem;
  }
`;

function LandingPage() {
  return (
    <Section className="container">
      <div className="row align-items-center">
        <div className="col-md-7 text-md-start text-center">
          <h3
            style={{
              fontSize: "3rem",
              color: "var(--text-color)",
              fontWeight: "lighter",
            }}
          >
            Hi, I’m
          </h3>
          <h1 className="title">Devika U H</h1>
          <SubText>
            A passionate designer and developer who loves to create
            user-friendly and functional solutions.
          </SubText>
          <div>
            <Button>My resume</Button>
            <Button>Contact Me</Button>
          </div>
        </div>

        <div className="col-md-5 text-center">
          <img
            src="assets/Profile-pic.jpg"
            alt="profile"
            style={{ height: "500px", width: "400px" }}
          />
          {/* <ImageContainer>
            <ProfileImage src="assets/Profile-pic.jpg" alt="profile" />
          </ImageContainer> */}
        </div>
      </div>
    </Section>
  );
}

export default LandingPage;
